import * as Yup from 'yup';

export const FilterFormSchema = Yup.object().shape({
    applicationStatus: Yup.string(),
    applicationCategory: Yup.string(),
});
